export function htmlZuText(html?: string): string {
  if (!html) {
    return '';
  }

  // Trennzeichen im Markup einfügen, bevor der Text extrahiert wird:
  // <br> in jeder Schreibweise, auch mit Attributen: Ein Leerzeichen
  // öffnendes <ul> <ol> : Ein Doppelpunkt mit Leerzeichen
  // öffnendes <li> <p> <div> <h1..h6> <tr> <table> <blockquote>: Ein Semikolon mit Leerzeichen
  // schließendes </li> </p> </div> </h1..h6> </tr> </blockquote>: Ein Semikolon mit Leerzeichen
  const mitTrennern = html
    .replace(/<br[^>]*>/gi, ' ')
    .replace(/<(ul|ol)[^>]*>/gi, ': ')
    .replace(/<(li|p|div|h[1-6]|tr|table|blockquote)[^>]*>/gi, '; ')
    .replace(/<\/(li|p|div|h[1-6]|tr|blockquote)[^>]*>/gi, '; ');

  const text = new DOMParser().parseFromString(mitTrennern, 'text/html').body.textContent ?? '';

  // Trennzeichen und Leerraum vereinheitlichen:
  // mehrfacher Leerraum: ein Leerzeichen, an erster Stelle um lange Leerraumfolgen vor der Verarbeitung zu entfernen
  // ein oder mehrere Semikolons mit Leerraum: ein Semikolon plus Leerzeichen
  // Semikolon neben Doppelpunkt (in beiden Richtungen) mit Leerraum: Doppelpunkt plus Leerzeichen
  // Satzzeichen gefolgt von eingefügtem Trenner: nur das Satzzeichen
  // mehrfacher Leerraum: ein Leerzeichen, erneut um mehrfache Leerzeichen aus Ersetzungen zu entfernen
  // Trenner am Textanfang: Entfernt
  // Trenner am Textende: Entfernt
  return text
    .replace(/\s+/g, ' ')
    .replace(/\s*;(?:\s*;)*\s*/g, '; ')
    .replace(/\s*;\s*:/g, ': ')
    .replace(/\s*:\s*;/g, ': ')
    .replace(/([.,:!?])\s*[;:]/g, '$1 ')
    .replace(/\s+/g, ' ')
    .replace(/^[;:\s]+/, '')
    .replace(/[;:\s]+$/, '');
}
